module.exports = __webpack_public_path__ + "static/media/ChronicleDisp-Roman_Web.d5f78406.woff";